import src from "IMAGE";
export default { src, width: 363, height: 72, blurWidth: 8, blurHeight: 2, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAYAAABllJ3tAAAATUlEQVR42gFCAL3/ABUhNGgQGShQCQ4WKQsRGzMKDxgsChAZLwsRGzMLERoxABYiNmwSHC1ZCAwTIwkOFikHCxIiCAwTJAgNFSgIDBMkARgHIHJ8jcMAAAAASUVORK5CYII="};
